module.exports = __webpack_public_path__ + "img/20190519_194800_0000.f6034097.png";